
<template>
    <div class="table-responsive lead_table" style="overflow:initial;" ref="formContainer">

      <table class="table table-hover" id="dataTable" cellspacing="0" >
        <thead style=" border-bottom: 1px solid #93a8d6; border-top: 1px solid #93a8d6;">
          <tr style="background-color: #f4f8fa;">
            <!-- <td class="text-left" v-if="flag && checkboxAll">
              <input type="checkbox" class="bg-default" style="cursor: pointer" value="1" v-on:change="changeAllChecboxes()" id="user_parent_row" name="" />
            </td>
            <td class="text-left" v-else-if="flag && !checkboxAll">
              <input type="checkbox" :indeterminate.prop="true" class="bg-default uncheckBox" style="cursor: pointer" value="1" v-on:change="changeAllChecboxes($event)" id="user_parent_row" name="" />
            </td> -->
            <!-- <td v-if="flag"></td> -->
             <td>
              Caller Name
             </td>
            <td>
              Total Calls
            </td>
          </tr>
        </thead>
        <tbody>
          <!-- <tr  v-if="isLoader" id="table_row" >
            <td colspan="17">
              <b-skeleton-wrapper >
                  <b-skeleton height="40px" ></b-skeleton>   
                  <b-skeleton height="40px"></b-skeleton>  
                  <b-skeleton height="40px"></b-skeleton>                                     
              </b-skeleton-wrapper> 
            </td>
          </tr> -->
          <tr v-show="!isLoader" v-for="(callh, index) in supportUser.slice(0, 5)"  :key="index" v-bind:class="[callh.id ? 'id-' + callh.id : '']" style="height: 63px;">
            <!-- Check Box -->
            <td>{{ callh.caller_name }}</td>
            <td>{{ callh.calls }}</td>

           
          </tr>
          <tr v-if="supportUser.length < 1 && !isLoader" style="height: 32.2vh">
            <td colspan="15">
              <h6 class="text-center">No Data Found!</h6>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- Pagination  -->
        <!-- <div v-if="!isLoader" class="row mt-1 justify-content-end d-flex align-items-center px-3">
          <div class="pt-0 display-rows">
            <span class="pr-3 font-weight-light">Total Organizations</span>
            <span class="pr-5 color-default text-decoration-underline font-weight-bold">{{  }} </span>
            <span class="pr-3 font-weight-light">Display Rows</span><span class="pr-5 mr-3 color-default font-weight-bold text-decoration-underline">{{  }}</span>
          </div>
          
          <paginate  v-show="totalRows > 0" v-model="currentPage" :page-count="totalPages" :click-handler="setPage" :prev-text="''" :next-text="''" :first-button-text="''" :last-button-text="''" :first-last-button="true" :container-class="'pagination pagination-sm mb-0'" :page-class="'page-item'" :prev-class="'page-item prev'" :next-class="'page-item next'" :page-link-class="'page-link'" :prev-link-class="'page-link'" :next-link-class="'page-link'"></paginate>
        </div> -->
    </div>
  </template>
  
  <script>

    import moment from "moment";
    import axios from 'axios';
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
    import Multiselect from "vue-multiselect";
    import "vue-multiselect/dist/vue-multiselect.min.css";
    Vue.filter("formatDate", function (value) {
      if (value != "0000-00-00 00:00:00" && value != null) {
        return moment(String(value)).format("MMM DD, Y LT");
      }
    });
    
    export default {
      components: {Multiselect},
      props: [
        // "demo",
        "supportUser",
        // "totalPages",
        // "page",
        // // "title",
        // "flag",
        // "total",
        // "totalRows",
        // "assign_filter",
        // "currentPage",
        // "crm_id",
        // "setskeletonLoader",
        // "tag",
      ],
      data() {
        return {
          endDate:'',
          startDate:'',
          fromDate: '',
          toDate: '',
          isLoader: true,
          myDate: "",
          st: "",
          role: '',
          show: true,
          dots: false,
          showstatus: false,
          upHere: false,
          checkAll: true,
          search: "",
          demo_id: "",
          edit_id: "",
          lead_status: "",
          lead_id: "",
          awaitingSearch: false,
          note: "",
          note_date: "",
          selectTab: "",
          message: "",
          created_at: "",
          suitable_date: "",
          status: 'all',
          countUnchecked: 0,
          checkboxAll: true,
          sortDirection: {
            company: true,
            name: true,
            followup_date: true,
            demo_date_note: true,
          },
          adminUsers:[],
          value:[],
          showCog:false,
          cogTypes:[],
          cogOptionsSelected:[],
          select_followUp:[],
          short_term_filter: [
            { name: "Today", start_date: moment().format('YYYY-MM-DD'), end_date: moment().format('YYYY-MM-DD'), value: "0" },
            { name: "Yesterday", start_date: moment().subtract(1, 'days').format('YYYY-MM-DD'), end_date: moment().subtract(1, 'days').format('YYYY-MM-DD'), value: "1" },
            { name: "Last week", start_date: moment().subtract(1, 'weeks').startOf('isoWeek').format('YYYY-MM-DD'), end_date: moment().subtract(1, 'weeks').endOf('isoWeek').format('YYYY-MM-DD'), value: "3" },
            { name: "This week", start_date: moment().startOf('isoWeek').format('YYYY-MM-DD'), end_date: moment().endOf('isoWeek').format('YYYY-MM-DD'), value: "4" },
            { name: "Last Month", start_date: moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'), end_date: moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'), value: "6" },
            { name: "This Month", start_date: moment().startOf('month').format('YYYY-MM-DD'), end_date: moment().endOf('month').format('YYYY-MM-DD'), value: "7" },
            { name: "Last Year", start_date: moment().subtract(1, 'years').startOf('year').format('YYYY-MM-DD'), end_date: moment().subtract(1, 'years').endOf('year').format('YYYY-MM-DD'), value: "9" },
            { name: "This Year", start_date: moment().startOf('year').format('YYYY-MM-DD'), end_date: moment().endOf('year').format('YYYY-MM-DD'), value: "10" },
            { name: "Custom Date", start_date: "", end_date: "", value: "12" }
          ],
        };
      },
      created() {
        this.select_followUp  =this.short_term_filter[0];
      },
      computed: {
        currentPage: {
          get: function () {
            this.showstatus = false;
            this.selectTab = localStorage.getItem("tab");
            return this.page4;
          },
          set: function () { },
        },
        tags: function(){
          return this.$store.getters["users/tags"];
        },
        showskLoader: function () {
          this.isLoader = this.setskeletonLoader;
          return this.setskeletonLoader;
        }
      },
      mounted: function () {
       
      
        this.isLoader = this.setskeletonLoader;
        this.role = localStorage.getItem('role');
        this.showstatus =false;
        this.edit_id = false;
        if(hasPermission('lead_list')){
          const permissionlist = {
            headers: {
              'X-Permission': 'lead_list'
            }
          };
          axios.get('/admin/users/get-all-users?role_id=' + 2,permissionlist)
          .then((response) => {
            let res = response.data;
            this.adminUsers = res.data;
          });
        }


      },
      watch:{
        showskLoader: function () {
          this.selectTab = localStorage.getItem("tab");
          this.isLoader = this.setskeletonLoader;
          return this.setskeletonLoader;
        }
      } ,
      
      methods: {
        shortTerm(event) {
          if(event.value!=12){
            var loader = this.$loading.show({
              loader: "dots",
            });
          }

            this.select_followUp = event;
            let user_name = this.userFilter ? this.userFilter.name : '';
            this.startDate = event.start_date;
            this.endDate = event.end_date;
            this.fromDate = '';
            this.toDate = '';
            if(event.value!=12){
              this.$emit('dateFilters', event.start_date , event.end_date,user_name);
            }

          setTimeout(() => {
            loader.hide();
          }, 2000);
        },
        applyFilter(e) {

          let user_name = this.userFilter ? this.userFilter.name : '';
          this.startDate  = this.fromDate;
          this.endDate = this.toDate;
          if(this.fromDate && this.toDate){
            var loader = this.$loading.show({
              loader: "dots",
            });
            this.$emit('dateFilters', this.fromDate , this.toDate,user_name);
          }
          if(this.fromDate=='' && this.toDate==''){
            var loader = this.$loading.show({
              loader: "dots",
            });
            this.$emit('dateFilters', '' , '',user_name);
          }

          setTimeout(() => {
            loader.hide();
          }, 2000);

        },
        setPage(page) {
          //  console.log(localStorage.getItem('setPageDirection'));
          this.$emit("setPage",page);
      
        },
       
        
      },
    };
  </script>
  <style>
  
    /* ul.dropdown-menu.dashboard-actions.show {
      transform: translate3d(-132px, -240px, 0px) !important;
    } */
    .form-control {
      font-size: 13px;
    }
  
    .popover {
      white-space: pre-line;
      max-width: 221.34px;
      font-family: Mulish, sans-serif;
      font-size: 16px;
      font-weight: 400;
      border: 1px solid #9fb4c3;
      border-radius: 8px;
      padding: 8px;
    }
  
    /* .tooltip {
      border: 1px solid black;
    } */
  
    .demo {
      margin-top: 5px;
      background: azure;
    }
  
    .dropdown {
      position: relative;
      display: inline-block;
    }
  
    .dropdown-content {
      display: none;
      position: absolute;
      background-color: white;
      width: 140px;
      border-radius: 10px;
      border: 1px solid #b6c7d2;
      right: 100%;
      z-index: -1;
      margin-top: -30px;
    }
  
    .dropdown-content button {
      display: block;
      width: 100%;
      text-align: left;
      padding: 0px 0 5px 15px;
    }
  
    .dropdown-content button:hover {
      border-radius: 2px;
      background-color: #edf2f5;
    }
  
    .dropdown:hover .dropdown-content {
      display: block;
    }
  
    a.btn:focus {
      background-color: #48a6a6;
      color: white;
    }
  
    .dropdown-menu a:hover {
      border-radius: 2px;
      color: white;
      background-color: #48a6a6;
    }
  
    .discovery_status {
      color: #a682b2;
      font-weight: 700;
      font-size: 12px;
    }
  
    .qualified_status {
      color: #a682b2;
      font-weight: 700;
      font-size: 12px;
    }
  
    .dead_status {
      color: #a682b2;
      font-weight: 700;
      font-size: 12px;
    }
  
    .reject_status {
      color: #a682b2;
      font-weight: 700;
      font-size: 12px;
    }
    .tooltip{
      border: 0px solid black !important;
      top: -24px !important;
    }
    .tooltip.bs-tooltip-top{
       top: 24px !important;
    }
    .tooltip .tooltip-inner {
      max-width: 200px !important;
      padding: 0.25rem 0.5rem !important;
      color: #000000de !important;
      text-align: center !important;
      background-color: #dbddde !important;
      border-radius: 0.25rem !important;
      font-size: 12px !important;
      font-weight: 500 !important;
    }
  </style>
  
  <style scoped>
  
     table tr td:not(:nth-child(1)):not(:nth-child(4)){
       padding: 0.75rem 0.3rem;
     }
    tbody tr{
      font-size: 13px !important; 
    }
    /* table tr td:nth-child(1) {
     
      padding: 0.5rem 0.25rem;
    } */
   
  
    table tr td:nth-child(4) {
      width: 8.5% !important;
    }
  
    table tr td:nth-child(5) {
      width: 6% !important;
    }
  
    table tr td:nth-child(6) {
      width: 6% !important;
    }
  
    table tr td:nth-child(7) {
      width: 6% !important;
    }
  
    table tr td:nth-child(8) {
      width: 3% !important;
    }
  
    table tr td:nth-child(9) {
      width: 5% !important;
    }
     table tr td:nth-child(10) {
      width:7.5% !important;
    }
  
    table tr td:nth-child(11) {
      width: 7% !important;
    }
  
    table tr td:nth-child(12) {
      width: 7.5% !important;
      padding: 0;
    }
  
    table tr td:nth-child(13) {
      width: 8.5% !important;
    }
  
    table tr td:nth-child(14) {
      width: 5% !important;
    }
  
    table tr td:nth-child(15) {
      width: 5% !important;
      padding: 0;
  
    }
  
    table tr td:nth-child(16) {
      width: 11% !important;
      padding: 0.75rem 0.5rem;
    }
    table tr td:nth-child(17) {
      width: 1.5% !important;
      padding: 0.75rem 0.5rem;
    }
    .text-primary{
      color: rgb(72, 166, 166) !important;
    }
     .table-responsive .row {
       padding: 0px 20px 16px 20px;
       -webkit-box-align: center;
       -ms-flex-align: center;
       align-items: center;
     }
  </style>